import { LINKS, COPY } from "@/lib/site";
import { scrollToId } from "@/lib/lenisManager";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-cream border-t border-line">
      <div className="container-editorial py-16 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10">
          <div>
            <button
              onClick={() => scrollToId("home")}
              className="font-display text-6xl md:text-7xl leading-none tracking-tight"
              data-testid="footer-logo"
            >
              SONA
            </button>
            <p className="mt-4 font-display italic text-2xl text-clay">
              {COPY.footer.tagline}
            </p>
          </div>

          <nav className="flex flex-wrap gap-x-8 gap-y-3" aria-label="Footer">
            <a data-testid="footer-instagram" href={LINKS.instagram} target="_blank" rel="noopener noreferrer" className="text-[12px] uppercase tracking-[0.16em] text-ink/70 hover:text-ink transition-colors">
              Instagram
            </a>
            <a data-testid="footer-youtube" href={LINKS.youtube} target="_blank" rel="noopener noreferrer" className="text-[12px] uppercase tracking-[0.16em] text-ink/70 hover:text-ink transition-colors">
              YouTube
            </a>
            <a data-testid="footer-email" href={LINKS.email} className="text-[12px] uppercase tracking-[0.16em] text-ink/70 hover:text-ink transition-colors">
              Email
            </a>
            <a data-testid="footer-whatsapp" href={LINKS.whatsapp} target="_blank" rel="noopener noreferrer" className="text-[12px] uppercase tracking-[0.16em] text-ink/70 hover:text-ink transition-colors">
              WhatsApp
            </a>
          </nav>
        </div>

        <div className="mt-14 pt-6 hairline flex flex-col sm:flex-row justify-between gap-3 text-xs text-ink/50 font-light">
          <span>{COPY.footer.copyright}</span>
          <span>{COPY.footer.metaLine}</span>
        </div>
      </div>
    </footer>
  );
};
